import React, { Component } from 'react';
import { Email, Telefone, Matricula } from '@/Componentes';
import { AlunoCell } from '@/Componentes/AlunoCell';
import { formatDateTimePtBr } from '@/utils';
import api from '@api';

export default class ListarRequerimentos extends Component {
	constructor() {
		super();
		this.state = {
			listaDeRequerimentos: [],
		};

		this.carregarListaDeRequerimentos = this.carregarListaDeRequerimentos.bind(this);
		this.apagarRequerimento = this.apagarRequerimento.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.carregarListaDeRequerimentos();
	}

	carregarListaDeRequerimentos() {
		api.requerimentos.ListaRequerimentos()
			.then((listaDeRequerimentos) => this.setState({ listaDeRequerimentos }))
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	linkParaBaixarRequerimento(id) {
		return `${api.requerimentos.getBaseUrl()}/${id}/baixar`;
	}

	apagarRequerimento(id) {
		api.requerimentos.RemoveRequerimentoPelaId(id)
			.then(() => {
				this.setState(prevState => {
					const listaDeRequerimentos = prevState.listaDeRequerimentos.filter(requerimento => requerimento.id !== id);
					return ({ listaDeRequerimentos });
				});
			})
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	render() {
		const { listaDeRequerimentos } = this.state;

		return (
			<div>
				<h5>Relação de Requerimentos</h5>
				<table className="table table-striped table-hover">
					<thead>
						<tr>
							<th></th>
							<th colSpan={2}>Estagiário</th>
							<th>Local</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{
							listaDeRequerimentos.map(({ aluno, local_do_estagio, orientador, supervisor, ...requerimento }, i) => {
								const downloadLink = this.linkParaBaixarRequerimento(requerimento.id);
								return (
									<tr key={requerimento.id}>
										<td>
											{i + 1}
										</td>
										<td>
											<AlunoCell aluno={aluno} />
											<div><small>Requerido em: {formatDateTimePtBr(new Date(requerimento.criado_em))}</small></div>
										</td>
										<td>
											<div><small>CPF: {aluno.cpf}</small></div>
											<div><small>Matrícula: <Matricula value={aluno.matricula} /></small></div>
										</td>

										<td>
											<div><small>Local: {local_do_estagio.nome} | <Telefone value={local_do_estagio.telefone} /> | {local_do_estagio.endereco.cidade} - {local_do_estagio.endereco.uf}</small></div>
											<div className="border-bottom" />
											<div><small>Orientador: {orientador.nome}</small></div>
											<div className="border-bottom" />
											<div><small>Supervisor: {supervisor.nome}</small></div>
											<div><small><Telefone value={supervisor.telefone} /> {supervisor.email && <> | <Email value={supervisor.email} /></>}</small></div>
										</td>
										<td>
											<button onClick={() => window.open(downloadLink, '_blank')}>Baixar</button>
											<button onClick={() => this.apagarRequerimento(requerimento.id)}>Apagar</button>
										</td>
									</tr>
								);
							})
						}
					</tbody>
				</table>
			</div>
		);
	}
}
